import { render, staticRenderFns } from "./BooleanCheckbox.vue?vue&type=template&id=42be4bb6&"
import script from "./BooleanCheckbox.vue?vue&type=script&lang=js&"
export * from "./BooleanCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports